// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zPUJz","fullView":"styles_fullView__2r5p8"};